import { ComponentChildren } from 'preact'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { IconUse } from '@bonniernews/dn-design-system-web/components/icon-sprite/icon-sprite.tsx'

export interface FormFieldProps {
  error?: boolean
  errorMessage?: string
  wrapperClasses?: string
  helpHtml?: string
  helpText?: string
  type?: string
  children?: ComponentChildren
}

export const FormField = ({
  error,
  errorMessage,
  wrapperClasses,
  helpHtml,
  helpText,
  type,
  children,
}: FormFieldProps) => {
  const classes = formatClassString([
    'ds-form-field',
    wrapperClasses,
    error && `ds-form-field__error`,
    type === 'hidden' && 'hidden',
  ])

  const showHelp = helpHtml || helpText
  return (
    <div className={classes}>
      {children}
      {errorMessage && (
        <div className='ds-form-field__error-message js-field-error'>
          <IconUse iconName='info-filled' />
          <span>{errorMessage}</span>
        </div>
      )}

      {showHelp && <p className='ds-form-field__help-text'>{helpHtml ? helpHtml : helpText}</p>}
    </div>
  )
}

export default FormField
